import { render, staticRenderFns } from "./ToBeCreated.vue?vue&type=template&id=56b80b96&scoped=true&"
import script from "./ToBeCreated.vue?vue&type=script&lang=js&"
export * from "./ToBeCreated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b80b96",
  null
  
)

export default component.exports